import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientListComponent } from './view/client-list/client-list.component';
import { NewExhibitorComponent } from './view/client-list/new-exhibitor/new-exhibitor.component';
import { CreateClientComponent } from './view/client-list/create-client/create-client.component';
import { TestViewComponent } from './view/test-view/test-view.component';
import { FloorComponent } from './view/floor-plan/floor.component';
import { ReportingComponent } from './view/reporting/reporting.component';
import { EtatSortieComponent } from './view/etat-sortie/etat-sortie.component';
import { BadgesComponent } from './view/badges/badges.component';
import { DashboardComponent } from './view/dashboard/dashboard.component';
import { InviationsvisaComponent } from './shared/formsClient/inviationsvisa/inviationsvisa.component';
import { LogistiqueComponent } from './view/logistique/logistique.component';
import { AdminComponent } from './view/admin/admin.component';
import { AuthGuard } from './view/login/login.guard';
import { LoginComponent } from './view/login/login.component';
import { InvoicesParticipantsComponent } from './view/invoices-participants/invoices-participants.component';
import { ConferenceComponent } from './view/conference/conference.component';
 

const routes: Routes = [  // 1st Route
  { path: '', redirectTo: 'client-list', pathMatch: 'full' },

  { path: 'client-list/:typeClient/:idUser', data: { breadcrumb: 'Clients' }, component: ClientListComponent , canActivate: [AuthGuard]},
  { path: 'login', component: LoginComponent },
  { path: 'admin', data: { breadcrumb: 'reporting' }, component: AdminComponent, canActivate: [AuthGuard] },
  { path: 'conference', data: { breadcrumb: 'Conférence' }, component: ConferenceComponent, canActivate: [AuthGuard] },

 

  { path: 'logistique', data: { breadcrumb: 'reporting' }, component: LogistiqueComponent },
  { path: 'reporting', data: { breadcrumb: 'reporting' }, component: ReportingComponent, canActivate: [AuthGuard] },
  { path: 'invitations', data: { breadcrumb: 'invitations' }, component: InviationsvisaComponent, canActivate: [AuthGuard] },
  { path: 'invoices', data: { breadcrumb: 'Invoices' }, component: InvoicesParticipantsComponent, canActivate: [AuthGuard] },
  { path: 'dashboard', data: { breadcrumb: 'reporting' }, component: DashboardComponent, canActivate: [AuthGuard] },

  { path: 'badges', data: { breadcrumb: 'badges' }, component: BadgesComponent, canActivate: [AuthGuard] },

  { path: 'etatsortie', data: { breadcrumb: 'etatsortie' }, component: EtatSortieComponent, canActivate: [AuthGuard] },
  { path: 'app-test-view', data: { breadcrumb: 'Clients' }, component: TestViewComponent, canActivate: [AuthGuard] },
  { path: 'app-floor', data: { breadcrumb: 'Floor' }, component: FloorComponent, canActivate: [AuthGuard] },

  { path: 'client-list/:typeClient/:idUser/:idClient', data: { breadcrumb: 'Detail Client' }, component: ClientListComponent, canActivate: [AuthGuard] },

  { path: 'add-client/:idProspect', data: { breadcrumb: 'Prospect' }, component: CreateClientComponent, canActivate: [AuthGuard] },
  // 2nd Route
  { path: 'add-exhibitor', data: { breadcrumb: 'Créer Fiche' }, component: NewExhibitorComponent, canActivate: [AuthGuard] },
  { path: 'add-exhibitor/:idClient', data: { breadcrumb: 'Créer Fiche' }, component: NewExhibitorComponent, canActivate: [AuthGuard] },
  { path: 'add-exhibitor/:idClient/:idDetail', data: { breadcrumb: 'Detail Fiche' }, component: NewExhibitorComponent, canActivate: [AuthGuard] }];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
